import React from 'react';

import { styled } from '@mui/material/styles';

import {Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper} from '@mui/material';
import { CardContent } from '@mui/material';

const PREFIX = 'ProgressTrackerTable';

const classes = {
    head: `${PREFIX}-head`,
    body: `${PREFIX}-body`,
    table: `${PREFIX}-table`
};

const StyledCardContent = styled(CardContent)({
    [`& .${classes.table}`]: {
        minWidth: 500,
    }
});

const StyledTableCell = TableCell;

const ProgressTrackerTable = ({budgetData, isModal}) => {


    const rows = [
        { description: 'Design Review', percent_complete: 100},
        { description: 'Buyout', percent_complete: 90},
        { description: 'Submittal Review', percent_complete: 50},
        { description: 'Punchlist', percent_complete: 100},
        { description: 'Precon Meetings', percent_complete: 100},
        { description: 'Wrap Up', percent_complete: 1},
        { description: 'Design Review', percent_complete: 100},
       
    ];

    return (
        <StyledCardContent >
            <TableContainer className={isModal ? classes.tableContainer : ''} component={Paper} style={{ maxHeight: isModal ? '100%' : '250px' }}>
                <Table className={classes.table} aria-label="payment history table">
                    <TableHead>
                        <TableRow>
                            <StyledTableCell
                                classes={{
                                    head: classes.head,
                                    body: classes.body
                                }}>Description</StyledTableCell>
                            <StyledTableCell
                                classes={{
                                    head: classes.head,
                                    body: classes.body
                                }}>% Complete</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((row, index) => (
                            <TableRow key={index}>
                                <StyledTableCell
                                    component="th"
                                    scope="row"
                                    classes={{
                                        head: classes.head,
                                        body: classes.body
                                    }}>
                                    {row.description}
                                </StyledTableCell>
                                <StyledTableCell
                                    component="th"
                                    scope="row"
                                    classes={{
                                        head: classes.head,
                                        body: classes.body
                                    }}>
                                    {row.percent_complete}%
                                </StyledTableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </StyledCardContent>
    );
};

export default ProgressTrackerTable;
